module.exports = __webpack_public_path__ + "static/media/UC-8631bac7-68c4-4bd6-b8cc-2c72490d1c06.3f78fdba.jpg";